import { useIntl } from "react-intl";

import { BackButton } from "@/components/BackButton/BackButton";

export function MyBookingHeader() {
  const intl = useIntl();

  return (
    <div className="mb-4 flex items-center justify-between px-2 py-4">
      <BackButton />
      <h3 className="font-medium text-text-title">
        {intl.formatMessage({
          id: "orderDetails",
          defaultMessage: "Order details",
        })}
      </h3>
      <div className="size-10" />
    </div>
  );
}
